import { useRoute } from 'vue-router'

export default function getAppidType() {
  let appIdData = ''
  const route = useRoute()
  const str = route.path.slice(route.path.lastIndexOf('/') + 1)
  if (route.path.includes('/fbu/marketingExport')) {
    appIdData = 'cos_zbu_fbu'
  } else if (route.path.includes('/lbu/marketingExport')) {
    appIdData = 'cos_zbu_lbu'
  } else if (str === 'fbu') {
    appIdData = 'cos_fbu'
  } else if (str === 'ofbu') {
    appIdData = 'cos_ofbu'
  } else if (str === 'lbu') {
    appIdData = 'cos_lbu'
  } else if (str === 'zbu') {
    appIdData = 'cos_zbu'
  }

  return { appIdData }
}
